import React from "react"
import I18n from 'i18n-js';
import '../translations.js';

export class AccountSearchTipsBig extends React.Component {

  render () {
    return (

      <div className="span12">
        <div dangerouslySetInnerHTML={{ __html: I18n.t("exhibitor.search_important_banner") }}></div>
        <p>
          <b>{ I18n.t("exhibitor.search_not_see") }</b>
        </p>
        <br/>
        <br/>
        <div className="alert alert-danger" dangerouslySetInnerHTML={{ __html: I18n.t("exhibitor.warning_create_one_account") }}></div>
        <div className="row">
          <div className="span12">
            <div className="hero-unit">
              <div className="accordion-group">
                <div className="accordion-heading">
                  <a className="accordion-toggle collapsed" data-toggle="collapse" href="#faq_22" aria-expanded="false">{ I18n.t("exhibitor.faq_22_header") }</a>
                </div>
                <div id="faq_22" className="accordion-body collapse" aria-expanded="false">
                  <div className="accordion-inner">{ I18n.t("exhibitor.faq_22_body") }</div>
                </div>
                <div className="accordion-heading">
                  <a className="accordion-toggle collapsed" data-toggle="collapse" href="#faq_23" aria-expanded="false">{ I18n.t("exhibitor.faq_23_header") }</a>
                </div>
                <div id="faq_23" className="accordion-body collapse" aria-expanded="false">
                  <div className="accordion-inner">{ I18n.t("exhibitor.faq_23_body") }</div>
                </div>
                <div className="accordion-heading">
                  <a className="accordion-toggle collapsed" data-toggle="collapse" href="#faq_24" aria-expanded="false">{ I18n.t("exhibitor.faq_24_header") }</a>
                </div>
                <div id="faq_24" className="accordion-body collapse" aria-expanded="false">
                  <div className="accordion-inner">{ I18n.t("exhibitor.faq_24_body") }</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
